import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { activateWorkspaceCode } from '../../../../api/workspaces/invite/activateWorkspaceCode';

export function useActivateWorkspaceCode() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: activateWorkspaceCode,
    onSuccess: () => {
      return queryClient.invalidateQueries(workspaceKeys.all);
    },
    onError: () => {
      //console.log('error');
    },
  });
}
